<template>
  <div class="password-overlay" :class="{ show: show }" @click.self="close">
    <div class="password-modal" @click.stop>
      <!-- 头部 -->
      <div class="password-header">
        <div class="header-icon">
          <svg viewBox="0 0 24 24" width="28" height="28" fill="none" stroke="currentColor" stroke-width="2">
            <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
            <path d="M7 11V7a5 5 0 0110 0v4" />
          </svg>
        </div>
        <h3 class="password-title">{{ $t('_ggtf._ssjymm') }}</h3>
        <button class="password-close" @click="close">
          <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M18 6L6 18M6 6l12 12" />
          </svg>
        </button>
      </div>

      <!-- 主体 -->
      <div class="password-body">
        <!-- 提示信息 -->
        <p class="password-hint">
          <span class="hint-dot">•</span>
          {{ $t('_ggtf._qssjymm') }}
        </p>

        <!-- 密码输入框 -->
        <div class="password-input-wrapper" :class="{ 'has-value': password.length > 0 }">
          <span class="input-icon">
            <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2">
              <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
              <path d="M7 11V7a5 5 0 0110 0v4" />
            </svg>
          </span>
          <input v-model="password" :type="showPassword ? 'text' : 'password'" class="password-input" :placeholder="$t('_ggtf._qssjymm')" maxlength="20" @keyup.enter="onSubmit" autofocus />
          <button class="password-toggle" @click="showPassword = !showPassword" type="button">
            <svg v-if="!showPassword" viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
              <circle cx="12" cy="12" r="3" />
            </svg>
            <svg v-else viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M17.94 17.94A10.07 10.07 0 0112 20c-7 0-11-8-11-8a18.45 18.45 0 015.06-5.94M9.9 4.24A9.12 9.12 0 0112 4c7 0 11 8 11 8a18.5 18.5 0 01-2.16 3.19m-6.72-1.07a3 3 0 11-4.24-4.24" />
              <line x1="1" y1="1" x2="23" y2="23" />
            </svg>
          </button>
        </div>

        <!-- 交易提示 -->
        <div class="transaction-tip">
          <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="#f97316" stroke-width="2">
            <circle cx="12" cy="12" r="10" />
            <line x1="12" y1="8" x2="12" y2="12" />
            <line x1="12" y1="16" x2="12.01" y2="16" />
          </svg>
          <span>{{ $t('_ggtf._jymmts') }}</span>
        </div>
      </div>

      <!-- 底部按钮 -->
      <div class="password-footer">
        <button class="password-btn password-btn-cancel" @click="close">
          {{ $t('_ggtf._qx') }}
        </button>
        <button class="password-btn password-btn-confirm" @click="onSubmit" :disabled="!password || loading">
          <span v-if="loading" class="spinner"></span>
          {{ loading ? $t('_ggtf._zfz') : okText || $t('_sp._qrzf') }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
// import { CloseCircleOutlined } from '@ant-design/icons-vue'

export default {
  name: 'PasswordVue',
  components: {
    //  CloseCircleOutlined
  },
  emits: ['sumbit', 'close'],
  props: {
    okText: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      show: false,
      password: '',
      showPassword: false,
      loading: false
    }
  },
  methods: {
    open() {
      this.password = ''
      this.showPassword = false
      this.loading = false
      this.show = true
      // 自动聚焦
      this.$nextTick(() => {
        const input = this.$el.querySelector('.password-input')
        if (input) input.focus()
      })
    },
    close() {
      this.show = false
      this.password = ''
      this.$emit('close')
    },
    onSubmit() {
      if (!this.password) {
        this.$message?.warning(this.$t('_ggtf._qssjymm'))
        return
      }
      this.loading = true
      this.$emit('sumbit', this.password)
    },
    // 供父组件调用以重置状态
    resetLoading() {
      this.loading = false
    }
  }
}
</script>

<style scoped>
/* ============================================================
   遮罩层
   ============================================================ */
.password-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(15, 23, 42, 0.6);
  backdrop-filter: blur(8px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10;
  opacity: 0;
  visibility: hidden;
  transition: all 0.3s ease;
  padding: 20px;
}

.password-overlay.show {
  opacity: 1;
  visibility: visible;
}

/* ============================================================
   主弹窗
   ============================================================ */
.password-modal {
  background: #ffffff;
  border-radius: 24px;
  width: 100%;
  max-width: 420px;
  box-shadow: 0 40px 80px rgba(0, 0, 0, 0.35);
  transform: scale(0.9) translateY(20px);
  transition: transform 0.35s cubic-bezier(0.34, 1.56, 0.64, 1);
  overflow: hidden;
}

.password-overlay.show .password-modal {
  transform: scale(1) translateY(0);
}

/* ============================================================
   头部
   ============================================================ */
.password-header {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 24px 28px 20px;
  background: linear-gradient(135deg, #f8fafc, #f1f5f9);
  border-bottom: 1px solid #eef2f6;
  position: relative;
}

.header-icon {
  width: 44px;
  height: 44px;
  background: linear-gradient(135deg, #f97316, #ea580c);
  border-radius: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #ffffff;
  flex-shrink: 0;
}

.password-title {
  font-size: 18px;
  font-weight: 700;
  color: #0f172a;
  margin: 0;
  flex: 1;
  letter-spacing: -0.3px;
}

.password-close {
  width: 36px;
  height: 36px;
  border: none;
  background: rgba(255, 255, 255, 0.8);
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #94a3b8;
  cursor: pointer;
  transition: all 0.2s;
  flex-shrink: 0;
}

.password-close:hover {
  background: #fee2e2;
  color: #ef4444;
  transform: rotate(90deg);
}

/* ============================================================
   主体
   ============================================================ */
.password-body {
  padding: 24px 28px 20px;
}

.password-hint {
  font-size: 14px;
  color: #64748b;
  margin: 0 0 20px 0;
  display: flex;
  align-items: center;
  gap: 8px;
}

.hint-dot {
  color: #f97316;
  font-size: 20px;
  font-weight: 700;
}

/* ============================================================
   密码输入框
   ============================================================ */
.password-input-wrapper {
  position: relative;
  display: flex;
  align-items: center;
  background: #f8fafc;
  border: 2px solid #e2e8f0;
  border-radius: 14px;
  transition: all 0.3s ease;
}

.password-input-wrapper:focus-within {
  border-color: #f97316;
  background: #ffffff;
  box-shadow: 0 0 0 4px rgba(249, 115, 22, 0.12);
}

.password-input-wrapper.has-value {
  border-color: #f97316;
  background: #ffffff;
}

.input-icon {
  padding: 0 0 0 16px;
  color: #94a3b8;
  display: flex;
  align-items: center;
  flex-shrink: 0;
}

.password-input {
  flex: 1;
  padding: 14px 12px;
  border: none;
  background: transparent;
  font-size: 16px;
  font-weight: 500;
  color: #0f172a;
  outline: none;
  letter-spacing: 2px;
  min-height: 54px;
}

.password-input::placeholder {
  color: #cbd5e1;
  font-weight: 400;
  letter-spacing: 0;
}

.password-toggle {
  padding: 0 16px 0 4px;
  border: none;
  background: transparent;
  color: #94a3b8;
  cursor: pointer;
  display: flex;
  align-items: center;
  transition: color 0.2s;
  flex-shrink: 0;
}

.password-toggle:hover {
  color: #f97316;
}

/* ============================================================
   交易提示
   ============================================================ */
.transaction-tip {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 16px;
  padding: 10px 14px;
  background: #fff7ed;
  border-radius: 10px;
  border: 1px solid #fed7aa;
}

.transaction-tip span {
  font-size: 13px;
  color: #9a3412;
}

/* ============================================================
   底部按钮
   ============================================================ */
.password-footer {
  display: flex;
  gap: 12px;
  padding: 16px 28px 24px;
  border-top: 1px solid #f1f5f9;
  background: #fafcff;
}

.password-btn {
  flex: 1;
  padding: 13px 0;
  border: none;
  border-radius: 12px;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.25s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.password-btn-cancel {
  background: #f1f5f9;
  color: #64748b;
}

.password-btn-cancel:hover {
  background: #e2e8f0;
  color: #0f172a;
}

.password-btn-cancel:active {
  transform: scale(0.97);
}

.password-btn-confirm {
  background: linear-gradient(135deg, #f97316, #ea580c);
  color: #ffffff;
  box-shadow: 0 4px 16px rgba(249, 115, 22, 0.3);
}

.password-btn-confirm:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 8px 24px rgba(249, 115, 22, 0.4);
}

.password-btn-confirm:active:not(:disabled) {
  transform: scale(0.97);
}

.password-btn-confirm:disabled {
  opacity: 0.5;
  cursor: not-allowed;
  transform: none;
}

/* ============================================================
   加载动画
   ============================================================ */
.spinner {
  display: inline-block;
  width: 18px;
  height: 18px;
  border: 2px solid rgba(255, 255, 255, 0.3);
  border-top-color: #ffffff;
  border-radius: 50%;
  animation: spin 0.7s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

/* ============================================================
   响应式
   ============================================================ */
@media (max-width: 480px) {
  .password-modal {
    max-width: 100%;
    border-radius: 20px;
  }

  .password-header {
    padding: 18px 20px 16px;
  }

  .header-icon {
    width: 38px;
    height: 38px;
  }

  .header-icon svg {
    width: 22px;
    height: 22px;
  }

  .password-title {
    font-size: 16px;
  }

  .password-body {
    padding: 18px 20px 16px;
  }

  .password-input {
    font-size: 15px;
    padding: 12px 10px;
    min-height: 48px;
  }

  .password-footer {
    padding: 14px 20px 18px;
    flex-direction: column-reverse;
    gap: 8px;
  }

  .password-btn {
    padding: 12px 0;
    font-size: 14px;
  }

  .password-hint {
    font-size: 13px;
  }

  .transaction-tip span {
    font-size: 12px;
  }
}
</style>
